/**
 * User configuration.
 */
/* tslint:disable */

const basicEditorConfig = {
  toolbar: [
    'heading',
    '|',
    'bold',
    'italic',
    'link',
    'bulletedList',
    'numberedList',
    'blockQuote',
    'undo',
    'redo',
  ],
};

const fullEditorConfig = {
  toolbar: [
    'heading',
    '|',
    'bold',
    'italic',
    'link',
    'bulletedList',
    'numberedList',
    '|',
    'indent',
    'outdent',
    '|',
    'blockQuote',
    'insertTable',
    'mediaEmbed',
    'undo',
    'redo',
  ],
};

module.exports = {
  public: {
    ANON: {
      editor: basicEditorConfig,
    },
    APPLICANT: {
      editor: basicEditorConfig,
    },
    RECRUITER: {
      editor: basicEditorConfig,
    },
    ADMIN: {
      editor: fullEditorConfig,
    },
  },
  server: {},
};
